module.exports = __webpack_public_path__ + "static/media/introduction-04.4d2ad192.png";